import { Action } from '../../actions';
import {
    CLOSE_GROUP_FILTERS_LIST_EDITOR,
    CloseGroupFiltersListEditorAction,
    DELETE_GROUP_FILTER,
    DeleteGroupFilterAction,
    GET_GROUP_FILTERS,
    GetGroupFiltersAction,
    OPEN_GROUP_FILTERS_LIST_EDITOR,
    OpenGroupFiltersListEditorAction,
    SET_GROUP_FILTERS,
    SetGroupFiltersAction,
    UPDATE_FILTERS_EDITOR_AUXILIARY_FILTER,
    UpdateFiltersEditorAuxiliaryFilterAction
} from '../../actions/groupsEdit';
import { CampaignType } from '../../typings/domain';
import {
    EditGroupFilterItem,
    EditGroupsState
} from '../../typings/groupsEditState';
import { State } from '../../typings/state';

const openGroupFilterListEditor = (
    state: EditGroupsState,
    action: OpenGroupFiltersListEditorAction
): EditGroupsState => {
    const group = state.groups[action.groupId];
    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        filtersEditor: {
                            auxiliaryFilter: '',
                            isOpen: true,
                            isLoading: false
                        }
                    }
                }
            };
        default:
            return state;
    }
};

const closeGroupFilterListEditor = (
    state: EditGroupsState,
    action: CloseGroupFiltersListEditorAction
): EditGroupsState => {
    const group = state.groups[action.groupId];
    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        filtersEditor: {
                            ...group.filtersEditor,
                            isOpen: false
                        }
                    }
                }
            };
        default:
            return state;
    }
};

const setGroupFilters = (
    state: EditGroupsState,
    action: SetGroupFiltersAction
): EditGroupsState => {
    const { groupId, filters } = action;
    const group = state.groups[groupId];

    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [groupId]: {
                        ...group,
                        value: {
                            ...group.value,
                            filters
                        },
                        filtersEditor: {
                            ...group.filtersEditor,
                            isLoading: false
                        }
                    }
                }
            };
        default:
            return state;
    }
};

const getGroupFilters = (
    state: EditGroupsState,
    action: GetGroupFiltersAction
): EditGroupsState => {
    const { groupId } = action;
    const group = state.groups[groupId];

    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [groupId]: {
                        ...group,
                        filtersEditor: {
                            ...group.filtersEditor,
                            isLoading: true
                        }
                    }
                }
            };
        default:
            return state;
    }
};

const deleteGroupFilter = (
    state: EditGroupsState,
    action: DeleteGroupFilterAction
): EditGroupsState => {
    const group = state.groups[action.groupId];
    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        value: {
                            ...group.value,
                            filters: group.value.filters.filter(
                                ({ id }: EditGroupFilterItem): boolean =>
                                    id !== action.filterId
                            )
                        }
                    }
                }
            };
        default:
            return state;
    }
};

const updateFiltersEditorAuxiliaryFilter = (
    state: EditGroupsState,
    action: UpdateFiltersEditorAuxiliaryFilterAction
): EditGroupsState => {
    const group = state.groups[action.groupId];
    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        filtersEditor: {
                            ...group.filtersEditor,
                            auxiliaryFilter: action.value
                        }
                    }
                }
            };
        default:
            return state;
    }
};

export const filtersReducer = (
    state: EditGroupsState,
    action: Action,
    fullState: State
): EditGroupsState => {
    switch (action.type) {
        case OPEN_GROUP_FILTERS_LIST_EDITOR:
            return openGroupFilterListEditor(state, action);

        case CLOSE_GROUP_FILTERS_LIST_EDITOR:
            return closeGroupFilterListEditor(state, action);

        case SET_GROUP_FILTERS:
            return setGroupFilters(state, action);

        case GET_GROUP_FILTERS:
            return getGroupFilters(state, action);

        case DELETE_GROUP_FILTER:
            return deleteGroupFilter(state, action);

        case UPDATE_FILTERS_EDITOR_AUXILIARY_FILTER:
            return updateFiltersEditorAuxiliaryFilter(state, action);

        default:
            return state;
    }
};
